<script>

import { Vue3Lottie } from 'vue3-lottie'
import LoadingJson from '../../assets/Json/Loading.json'

export default {
  name:'LoadingPage',
  components: {
    Vue3Lottie,
  },

  setup(){

    return{

      LoadingJson

    }
  }
}

</script>

<template>

  <Vue3Lottie class="loading" :animationData="LoadingJson" :height="400" :width="400" />

</template>

<style scoped>


</style>